import ContentfulCustomReactComponent from '@root/joinroot.com/src/models/contentful/contentful-custom-react-component';

export default function CustomReactComponentBlock({ content }) {
  const customReactComponent = ContentfulCustomReactComponent.createFromGraphqlContent(content);

  const ComponentToRender = customReactComponent.componentToRender;

  return <ComponentToRender anchor={content.anchor?.anchorSlug} />;
}

CustomReactComponentBlock.propTypes = {
  content: ContentfulCustomReactComponent.propType(),
};
